module.exports = __webpack_public_path__ + "img/DMichalakFoto.6f86d744.jpg";